import { BidTypes } from './types';
import { useBids, useBoughtBids } from './useBids';

type UseTableDataProps = {
  filter: any;
  pagination: any;
  sorting: any;
  bidType: BidTypes;
};

export const useTableData = ({ filter, pagination, sorting, bidType }: UseTableDataProps) => {
  // Only call the hook we actually need
  const bidsResult = useBids({
    filter,
    pagination,
    sorting,
    enabled: bidType !== BidTypes.Orders,
  });

  const boughtResult = useBoughtBids({
    filter,
    pagination,
    sorting,
    enabled: bidType === BidTypes.Orders,
  });

  return bidType === BidTypes.Orders ? boughtResult : bidsResult;
};
